import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import HomePage2 from '../HomePage2/HomePage2';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import ContactPage from '../ContactPage/ContactPage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetailsPage from '../BlogDetailsPage/BlogDetailsPage'; // Sudah ada

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="product/:slug" element={<ServiceSinglePage />} />
          <Route path="blog" element={<BlogPage />} />

          {/* INI YANG TADI LUPA LU TAMBAHIN: */}
          <Route path="blog-single/:slug" element={<BlogDetailsPage />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
